<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Login v1 -->
      <b-card class="mb-0">
        <div class="d-flex justify-content-center">
          <img
            width="250px"
            height="80px"
            :src="require('@/assets/images/logo/MinistryLogo.png')"
          />
        </div>

        <!-- form -->
        <validation-observer ref="loginForm">
          <b-form class="auth-login-form mt-2" @submit.prevent="login">
            <!-- email -->
            <b-form-group label-for="name" label="اسم المستخدم">
              <validation-provider
                #default="{ errors }"
                name="اسم المستخدم"
                rules="required"
                mode="passive"
              >
                <b-form-input
                  id="name"
                  v-model="username"
                  name="username"
                  :state="errors.length > 0 ? false : null"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">كلمة السر</label>
                <!-- <b-link :to="{ name: 'auth-forgot-password-v1' }">
                  <small>Forgot Password?</small>
                </b-link> -->
              </div>
              <validation-provider
                #default="{ errors }"
                name="كلمة السر"
                rules="required"
                mode="passive"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="login-password"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              :disabled="loading"
              class="mt-2"
              variant="primary"
              type="submit"
              block
            >
              <b-spinner class="align-middle mx-1" v-if="loading" small />
              تسجيل الدخول
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <span>لديك حساب منظمة ؟ </span>
          <b-link :to="{ name: 'auth-login' }">
            <span>تسجيل الدخول بصفة منظمة</span>
          </b-link>
        </b-card-text>
      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BButton,
  BForm,
  BSpinner,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import { required } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BSpinner,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      required,
      username: "",
      password: "",
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    ...mapGetters("Auth", ["loading"]),
  },
  methods: {
    ...mapActions("Auth", ["ministryLogin"]),
    async login() {
      await this.$refs.loginForm.validate().then(async (success) => {
        if (success) {
          await this.ministryLogin({
            username: this.username,
            password: this.password,
          }).then(() => {
            localStorage.setItem('fromLogin' , true)
            this.$router.push({ name: "ministry-dashboard" });
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
